

const { REACT_APP_ACCESS_TOKEN } = process.env;

async function httpRequset(method: string, enableAuthoriztion: string, contentType: string | null, url: string, body: any) {
  try {
    const headers = {
      "Content-Type": contentType,
      Authorization: `Bearer ${REACT_APP_ACCESS_TOKEN}`,
      // Authorization: enableAuthorization === apiConstatnts.ENABLE_AUTHORIZATION ? store.getState().auth.user!["token"] : null,
    };

    const options: RequestInit = {
      method: method,
      headers: headers,
      ...(body && { body: body }),
    };

    const response = await fetch(`${url}`, options as any);

    const rawData = await response.text();

    const data = JSON.parse(rawData);

    if (data?.statusCode !== 200) throw new Error(data?.message || "Error");

    return data.data;
  } catch (error) {
    throw error;
  }
}

export default httpRequset;
